import InfoIcon from '@mui/icons-material/Info';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import StorefrontIcon from '@mui/icons-material/Storefront';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

/**
 * @name AboutIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const AboutIcon = props => <InfoIcon { ...props } />;

/**
 * @name CollectionIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const CollectionIcon = props => <LibraryBooksIcon { ...props } />;

/**
 * @name HistoryIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
 export const HistoryIcon = props => <AccessTimeIcon { ...props } />;

/**
 * @name MarketIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const MarketIcon = props => <StorefrontIcon { ...props } />;

/**
 * @name MintIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const MintIcon = props => <SettingsSuggestIcon { ...props } />;

/**
 * @name OfferIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const OfferIcon = props => <LocalOfferIcon { ...props } />;

/**
 * @name TransferIcon
 * @constant
 * @function
 * @description 
 * @param {Cbject} props 
 * @returns {ReactComponentElement}
 */
export const TransferIcon = props => <MoveDownIcon { ...props } />;